import React from 'react';
import './Banner.css';

import { Button, Heading } from '../../../components';



const Banner = () => {

  return (
    <section className="banner">
      <div className='content'>

        <Heading title={"Discover Exceptional Flooring, Tiling, and Paving Solutions"} subTitle={"Enhance Your Interior"} linear sideHeading />
        <Button link={"Get-Quote"} title={"Get Quote"} />

      </div>
    </section>
  );

};

export default Banner;